import React, { useRef } from "react"
import Slider from "react-slick"
import ArticleCard from "../Reusable/ArticleCard"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

export default function ArticleSlider({ articles }) {
  const sliderRef = useRef(null)
  const cardRefs = useRef([])

  if (!articles) return null

  // Shuffle and limit to 16 articles because of the slider layout and number being output
  const shuffledEdges = [...articles.edges]
    .sort(() => Math.random() - 0.5)
    .slice(0, 16)

  const settings = {
    arrows: false,
    dots: true,
    infinite: false
  }

  cardRefs.current = []

  return (
    <Slider ref={sliderRef} {...settings}>
      {shuffledEdges.map((article, idx) => {
        const { id, uri, slug, title, Magazines, acfPageColour } = article.node
        const { featuredImage = "" } = Magazines
        return (
          <div className="slide" key={id}>
            <ArticleCard
              ref={el => (cardRefs.current[idx] = el)}
              link={uri}
              slug={slug}
              backgroundImage={featuredImage}
              readingTime={false}
              title={title}
              colour={acfPageColour.pageColour}
              texture={article.node.terms.nodes[0].slug < 2024 ? true : false}
              onFocus={() => sliderRef.current?.slickGoTo(idx)}
            />
          </div>
        )
      })}
    </Slider>
  )
}